import { NgModule } from '@angular/core';
import { SharedModule } from './../shared/shared.module';
import { HomeRoutingModule } from './home-routing.module';
import { HomeLangModule } from './home-lang.module';

import { IndexService } from './services/index.service';
import { MessageService } from './services/message.service';
import { AnouncementService } from './services/anouncement.service';
import { LoginService } from './services/login.service';
import { RegisterService } from './services/register.service';
import { PublicEnquiryService } from './services/public-enquiry.service';
import { AnoucementDetailResolver } from './components/anouncement-detail/ano-detail.resolver';

import { IndexComponent } from './components/system/index/index.component';
import { TopNavComponent } from './components/system/topNav/topNav.component';
import { HeadTopComponent } from './components/system/headTop/headTop.component';
import { UserEntComponent } from './components/system/userEnt/userEnt.component';
import { SideNavComponent } from './components/system/sideNav/sideNav.component';
import { IndustryAnimateComponent } from './components/login/industry-animate/industry-animate.component';
import { LoginComponent } from './components/login/login.component';
import { RegisterComponent } from './components/register/register.component';
import { NotFoundComponent } from './components/notFound/notFound.component';
import { HomeComponent } from './components/home/home.component';
import { AnouncementComponent } from './components/home/anouncement/anouncement.component';
import { AnouncementListComponent } from './components/anouncement-list/anouncement-list.component';
import { AnouncementDetailComponent } from './components/anouncement-detail/anouncement-detail.component';
import { MessageComponent } from './components/system/message/message.component';
import { MessageListComponent } from './components/message-list/message-list.component';
import { MessageBodyComponent } from './components/message-list/message-body/message-body.component';
import { EnquiryTop10Component } from './components/login/enquiry-top10/enquiry-top10.component';
import { EnquiryHomeComponent } from './components/home/enquiry-home/enquiry-home.component';
import { FindPsdComponent } from './components/find-psd/find-psd.component';
import { EntSelectModalComponent } from './components/system/userEnt/ent-select-modal/ent-select-modal.component';
import { QRCodeService } from './services/QRCode.service';
import { UserCenterComponent } from './components/userCenter/userCenter/userCenter.component';
import { PasswordComponent } from './components/userCenter/password/password.component';
import { UserInfoComponent } from './components/userCenter/userInfo/userInfo.component';
import { PasswordService } from './services/password.service';
import { RoleManageService } from '../manage/services/roleManage.service';
import { UserManageService } from '../manage/services/userManage.service';
import { UserService } from '../core/services/user.service';
import { UserInfoService } from './services/user-info.service';
import { OrderCountCubeService } from './services/orderCountCube.service';
import { HtmlPipe } from '../shared/pipes/html.pipe';

@NgModule({
    imports: [
        HomeRoutingModule,
        HomeLangModule,
        SharedModule
    ],
    declarations: [
        IndexComponent,
        TopNavComponent,
        HeadTopComponent,
        UserEntComponent,
        SideNavComponent,
        IndustryAnimateComponent,
        LoginComponent,
        RegisterComponent,
        NotFoundComponent,
        HomeComponent,
        AnouncementComponent,
        AnouncementListComponent,
        AnouncementDetailComponent,
        MessageComponent,
        MessageListComponent,
        MessageBodyComponent,
        EnquiryTop10Component,
        EnquiryHomeComponent,
        FindPsdComponent,
        EntSelectModalComponent,
        UserCenterComponent,
        PasswordComponent,
        UserInfoComponent,
        HtmlPipe
    ],
    exports: [
        IndexComponent
    ],
    providers: [
        IndexService,
        MessageService,
        AnouncementService,
        LoginService,
        RegisterService,
        AnoucementDetailResolver,
        PublicEnquiryService,
        QRCodeService,
        PasswordService,
        UserInfoService,
        UserService,
        OrderCountCubeService
    ]
})
export class HomeModule { }



// WEBPACK FOOTER //
// F:/WMS/X-xiamenzhuhe-SDM234/zhuhe-234/sdm_fe/src/app/home/home.module.ts